const DUMMY_NOTIFICATION_SOURCES = new Set(['cs', 'system'])

export function shouldShowDummyFeatures(mode) {
  return mode !== 'production'
}

export function shouldUseDummyNotificationSource(source, mode) {
  return !DUMMY_NOTIFICATION_SOURCES.has(source) || shouldShowDummyFeatures(mode)
}
